import { Box } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { LanguageContext } from "../../../../../context/LanguageContext";
import { ParagraphText, UBAppModal } from "../../../../../Libraries";
import FilterTabContent from "./FIlterTabContent";
import { DateFilter } from "../../../../../constants";
import { useSnackbar } from "../../../../../context/SnackbarContext";
import { analytics, triggerLogEvent } from "../../../../../config/firebase";

// const transactionFilter = ["All", "Money in", "Money out"];
const viewTransactionFilter = [
  { label: "All", value: "" },
  { label: "Recharge", value: "recharge" },
  { label: "Bill payments", value: "bill_payment" },
  { label: "Vouchers", value: "voucher_payment" },
  { label: "Saddar orders", value: "payment" },
];

export const initialFilters = {
  // transaction: transactionFilter[0],
  viewTransaction: "",
  dateType: DateFilter[0],
  startDate: null,
  endDate: null,
  fromAmount: null,
  toAmount: null,
};
const FilterModal = ({
  isOpen = false,
  handleClose,
  setFilters = () => {},
  filter,
  handleFilterLogEvent = () => {},
  handleSortLogEvent = () => {},
  handleClearLogEvent = () => {},
}) => {
  const { showSnackbar } = useSnackbar();

  const [filterOp, setFilterOp] = useState(initialFilters);
  const [I18n] = useContext(LanguageContext);


  const handleClear = () => {
    handleClearLogEvent();
    triggerLogEvent(analytics, "w_transactions_filter_removed");
    setFilterOp({
      ...initialFilters,
    });
    setFilters({ ...initialFilters });
    handleClose();
  };
  useEffect(() => {
    if (filter) {
      setFilterOp({
        ...filter,
        startDate: filter.dateType === "Custom" ? filter.startDate : null,
        endDate: filter.dateType === "Custom" ? filter.endDate : null,
      });
    }
  }, [filter, isOpen]);
  return (
    <UBAppModal
      id="ucash_all_transaction_filter_modal"
      size={"lg"}
      open={isOpen}
      handleClose={handleClose}
      className={"filterModal AccountFilter"}
      header={{
        CustomHeader: <></>,
        handleClose: () => {
          handleClose();
        },
      }}
      footer={[
        {
          data: {
            className: `newFontColor fontSize14 fontWeight400 textUppercase cursorPointer clear-btn`,
            title: `${I18n.clear} ${I18n.filter}`,
            onClick: () => handleClear(),
            id: "all_transactions_clear_filter",
          },
        },
        {
          data: {
            className: `newFontColor fontSize14 fontWeight400 textUppercase cursorPointer apply-btn`,
            title: I18n.apply,
            disabled: !((filterOp?.viewTransaction || []).length > 0),
            id: "all_transactions_apply_filter",
            onClick: () => {
              if (
                filterOp.dateType === "Custom" &&
                !filterOp.startDate &&
                !filterOp.endDate
              ) {
                showSnackbar({
                  message: I18n.please_select_start_end_date,
                  severity: "error",
                  icon: "",
                });
                return;
              }

              triggerLogEvent(analytics, "w_transactions_filter_applied");
              setFilters({ ...filterOp });
              handleClose();
            },
          },
        },
      ]}
    >
      <Box className="accountFilterModalBody">
        <Box className={`accountFilterModalTabBody`}>
          <ParagraphText className={"fontWeight500 fontSize18"}>
            {I18n.filter}
          </ParagraphText>

          <FilterTabContent
            viewTransactionFilter={viewTransactionFilter}
            filterOp={filterOp}
            setFilterOp={setFilterOp}
            dateFilter={DateFilter}
          />
        </Box>
      </Box>
    </UBAppModal>
  );
};

export default FilterModal;
